import { DataSource, Layout, Table} from "@mcleod/components";

export abstract class AutogenLayoutCommodityLookup extends Layout {
	sourceCommodity: DataSource;
	tableCommodity: Table;
}
